import * as React from 'react';

import {BaseRow} from 'shells/row/base-row/base-row';

import type {ChannelType} from 'nutshell-graphql-types';
import type {SourceFragment as Source} from 'nutshell-graphql-types';

import {ChannelSourceRowSelectState} from './channel-source-row-select-state';

export type CreatableState = 'channel' | 'source';

type Props = {
    creatableState: CreatableState;
    sourceOptions: Source[];
    existingChannels: ChannelType[];
    canAccessSetup: boolean;
    onAddChannel: (channel: ChannelType) => void;
    onSelectSource: (sourceId: string) => void;
    onCancel: () => void;
};

export function ChannelSourceCreatableRow(props: Props) {
    return (
        <div className='p-4'>
            <BaseRow type='sources'>
                <ChannelSourceRowSelectState
                    creatableState={props.creatableState}
                    onSelectChannel={props.onAddChannel}
                    existingChannels={props.existingChannels}
                    onSelectSource={props.onSelectSource}
                    sourceOptions={props.sourceOptions}
                    canAccessSetup={props.canAccessSetup}
                    onCancel={props.onCancel}
                />
            </BaseRow>
        </div>
    );
}
